import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { AttributeSetContainerModel } from '../../../../../../models/aggregates/erp/attribute/attribute-set-container.model';
import { ApiVisa } from '../../shared';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AttributeSetService extends BaseApiTemplateService<AttributeSetContainerModel> {
  // https://api-test.akaun.com/core2/tnt/dm/erp/attribute-sets
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ERP_PREFIX + 'attribute' + '/attribute-sets';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'attribute' + '/attribute-sets';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'attribute' + '/attribute-sets';
    this.httpClient = http;
  }

}
